// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html,body{margin:0;padding:0;font-family:sans-serif}", "",{"version":3,"sources":["webpack://./src/scss/main.scss"],"names":[],"mappings":"AAAA,UAEE,QAAA,CACA,SAAA,CAEA,sBAAA","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n\n  font-family: sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
